import axios from 'axios';

// search roles api
export async function searchModulesAPI(Data) {
	let moduleslist = [];
	const moduleName = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}system/modules/search/?moduleName=${moduleName}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		moduleslist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return moduleslist;
}

// check existing role api
export async function getModulesNameAPI(Data) {
	let moduleslist = [];
	const moduleName = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}system/modules/getModuleName/?moduleName=${moduleName}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		moduleslist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return moduleslist;
}

//create modules api
export async function createModulesAPI(Data, userID) {
	let modulesData = [];
	try{
		const axiosResponse = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}system/modules/create/`,
			data: {Data, userID}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		modulesData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return modulesData;
}

//update modules api
export async function updateModulesAPI(Data, moduleCode, userID) {
	let modulesData = [];
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}system/modules/update/?moduleCode=${moduleCode}&userID=${userID}`,
			data: Data
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		modulesData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return modulesData;
}